<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Shopping Configuration</span>
        </div>
    </div>
    <div class="card card_content">

        <div class="table-responsive mt-2 mb-4" >
            <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">

                <ng-container matColumnDef="productname">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="productname">Product Name</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        {{dataField.productName}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="popular">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="popular">Popular</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" class="text-center">
                        <mat-checkbox color="primary" [(ngModel)]="dataField.isPopular" (change)="check('pop',dataField)"></mat-checkbox>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="newarrival">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="newarrival">New Arrival</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" class="text-center">
                        <mat-checkbox color="primary" [(ngModel)]="dataField.isNewArrival" (change)="check('new',dataField)"></mat-checkbox>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="saleitems">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="saleitems">Sale Items
                        </mat-header-cell>
                    <mat-cell *matCellDef="let dataField" class="text-center">
                        <mat-checkbox color="primary" [(ngModel)]="dataField.isSaleItems" (change)="check('sales',dataField)" class="mr-2"></mat-checkbox>
                        <input type="text" placeholder="Enter Sale Cost Here" [(ngModel)]="dataField.saleCost">
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="outofstock">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="outofstock">Out Of Stock
                        </mat-header-cell>
                    <mat-cell *matCellDef="let dataField" class="text-center">
                        <mat-checkbox color="primary" [(ngModel)]="dataField.isOutOfStock"></mat-checkbox>
                    </mat-cell>
                </ng-container>


                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                </mat-row>
            </mat-table>
        </div>
        <div *ngIf="data.length===0" class="text-center">
            No Results Found
          </div>

          <div class="table_pagenation" [hidden]="dataSource?.filteredData.length<=50">
            <mat-paginator #paginator [length]="dataSource?.filteredData.length || 0" [pageIndex]="0" [pageSize]="50"
                [pageSizeOptions]="[50, 100]">
            </mat-paginator>
        </div>
        <div class="text-center">
            <button class="btn btn-secondary" (click)="submitShoppingConfiguration()">Submit</button>
        </div>
    </div>
</div>
